import { h } from 'preact'
import { AuthorType } from './Types'
import Phrase from '../../libs/translationsUtils/phrase'
import { common } from '../common'
import Tooltip from '../../control-components/ui-components/Tooltip'
import formatDateInLocalTimezone from '../utils/dateFormatDestination'

interface Props extends AuthorType {
  displayAuthor: boolean,
  repliedAt: string
}

const PostAuthorMeta = ({ id, username, reputation, displayAuthor, repliedAt }: Props) => {
  const replyTime = new Date(repliedAt).getTime()
  return (
    <div className='post__user__meta'>
      <ul className='list list--dot-seperated text--meta'>
        <li>
          <div className='group--inline'>
            {
              id.toString() === '' ?
                (<span className='list--post__username'> { username } </span>):
                (<a href={`/members/user-${id}`}>{ username }</a>)
            }
          </div>
        </li>
        {
          displayAuthor ? (
            <li className='list-item--no-dot'>
            <span className='pill pill--author pill--uppercase pill--inline'>
              <Phrase p='Author' />
            </span>
            </li>
          ) : null
        }
        <li className='is-hidden-S'>
          <Phrase p='topic.meta.post.reply' count={{ n: reputation.repliesMade.toString() }} />
        </li>
        <li className='list-item--float-right list-item--no-dot list-item--publish-date'>
          <Tooltip
            withArrow
            trigger={(
              <time> { common.relativeDate(replyTime) } </time>
            )}
            tooltipMessage={(
              <div className='tooltip__content tooltip__content--publish-date js-tooltip-content position--bottom'>
                { formatDateInLocalTimezone(replyTime) }
              </div>
            )}
          />
        </li>
      </ul>
    </div>
  )
}

export default PostAuthorMeta
